module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Techpad","short_name":"Techpad","start_url":"/","background_color":"#5c55e4","display":"minimal-ui","icon":"src/images/logo.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"77ba21c8a56c34ae6b9520b16d00e117"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
